import Admin from '../components/Admin';

export default Admin.compileFromLibrary([
  'GroupResource',
  {
    title: 'Tags',
    icon: 'tag',
    path: '/tags',
    redirect: [['redirect.unauthorized']],
    filters: [
      ['FilterRegexSearch', {
        id: 'search',
        col: 12,
        paths: ['name', 'type'],
        caseInsensitive: true,
        section: 'top',
      }],
      ['FilterField', {
        id: 'type',
        label: null,
        col: 12,
        section: 'top',
        VALUES_MAP: {
          any: null,
          topic: { type: 'TOPIC' },
          region: { type: 'REGION' },
        },
        buildQuery: (value, builder, filter) => (
          filter.VALUES_MAP[value]
            ? builder.add('where', { ...filter.VALUES_MAP[value] })
            : null
        ),
        getValueForField: value => (
          value && value.length
            ? value
            : 'any'
        ),
        field: ['FieldRadio', {
          name: 'active',
          block: true,
          prepareValueForInput: value => (value ? value : 'any'),
          initialValue: 'any',
          choices: [{
            label: 'All',
            value: 'any',
          }, {
            label: 'Topic',
            value: 'topic',
          }, {
            label: 'Region',
            value: 'region',
          }],
        }],
      }],
      ['FilterPagination', {
        id: 'pagination',
        section: 'bottom',
      }],
    ],
    archiveConfig: {
      icon: 'tag',
      title: 'Tags',
      label: 'Tags',
      createButtonPath: '/tags/create',
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/users/me',
        ],
      ],
    },
    singleConfig: {
      hidden: true,
      alias: '/tags',
      headerTitle: 'Create',
      backButtonLabel: 'Close',
      backButtonPaths: ['/tags'],
    },
    singleCreateConfig: {
      hidden: true,
    },
    singleEditConfig: {
      getBackButtonPaths: props => (
          props.viewer && props.viewer.role === 'ADMIN'
        ? props.backButtonPaths
        : false
      ),
      hidden: true,
    },
    columns: [
      { path: 'name', link: '/tags/:_id' },
      // eslint-disable-next-line max-len
      { path: 'type', width: '33%', render: record => `${record.type[0]}${record.type.slice(1).toLowerCase()}` },
      // {
      //   path: 'follow',
      //   title: 'Users can follow?',
      //   render: record => (record.follow ? 'YES' : 'NO'),
      // },
    ],
    fields: [
      ['FieldText', {
        name: 'name',
        rules: [['validation.isRequired']],
      }],
      // ['FieldSwitch', {
      //   name: 'follow',
      //   label: 'Users can follow this tag?',
      //   initialValue: false,
      //   // rules: [['validation.isRequired']],
      //   // hidden: true,
      // }],
      ['FieldSelect', {
        name: 'type',
        rules: [['validation.isRequired']],
        choices: [{
          label: 'Topic',
          value: 'TOPIC',
        }, {
          label: 'Region',
          value: 'REGION',
        }],
        disabled: [props => props.activity !== 'create'],
        virtual: [props => props.activity !== 'create'],
      }],
    ],
  },
]).pages;
